import { createAction, createReducer } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type ExclusionCheckStatus = "idle" | "loading" | "done" | "failed" | "missing-tenant";

export interface ExclusionCheckState {
  status: ExclusionCheckStatus;
  excluded: boolean;
  message?: string;
  zone?: { id: number; name: string };
}

const initialState: ExclusionCheckState = {
  status: "idle",
  excluded: false,
};

export const exclusionCheckCleared = createAction("exclusionCheck/cleared");
export const exclusionCheckMissingTenant = createAction("exclusionCheck/missingTenant");
export const exclusionCheckNotApplicable = createAction("exclusionCheck/notApplicable");
export const exclusionCheckStarted = createAction("exclusionCheck/started");
export const exclusionCheckSucceeded = createAction<{ excluded: boolean; message?: string; zone?: { id: number; name: string } }>("exclusionCheck/succeeded");
export const exclusionCheckFailed = createAction("exclusionCheck/failed");

export const selectExclusionCheck = (state: RootState) => state.exclusionCheck;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(exclusionCheckCleared, () => initialState)
    .addCase(exclusionCheckMissingTenant, (state) => {
      state.status = "missing-tenant";
      state.excluded = false;
      state.message = undefined;
      state.zone = undefined;
    })
    .addCase(exclusionCheckNotApplicable, (state) => {
      state.status = "done";
      state.excluded = false;
      state.message = undefined;
      state.zone = undefined;
    })
    .addCase(exclusionCheckStarted, (state) => {
      state.status = "loading";
      state.excluded = false;
      state.message = undefined;
      state.zone = undefined;
    })
    .addCase(exclusionCheckSucceeded, (state, action) => {
      state.status = "done";
      state.excluded = action.payload.excluded;
      state.message = action.payload.message;
      state.zone = action.payload.zone;
    })
    .addCase(exclusionCheckFailed, (state) => {
      state.status = "failed";
      state.excluded = false;
      state.message = undefined;
      state.zone = undefined;
    });
});
